import { useState } from 'react';
import { Product } from '../../../lib/store/products';
import { formatPrice, getPrice, getRegularPrice, getSalePrice, isProductOnSale } from '../../../utils/price';

interface Props {
    product: Product;
    onClick: (product: Product) => void;
}

export default function ProductCard({ product, onClick }: Props) {
    const [imageError, setImageError] = useState(false);

    const mainImage = product.images?.[0]?.src || null;
    const showPlaceholder = !mainImage || imageError;

    const displayPrice = getPrice(product);
    const displayRegularPrice = getRegularPrice(product);
    const displaySalePrice = getSalePrice(product);
    const onSale = isProductOnSale(product);

    const isInStock = () => {
        // Bezpieczne sprawdzanie stock_status — tak jak w działającym kodzie
        // referencyjnym: brak pola traktujemy jako "instock".
        const status = product.stock_status || 'instock';
        return status === 'instock' || status === 'onbackorder';
    };

    const inStock = isInStock();

    return (
        <div className="store__product-card" onClick={() => onClick(product)}>
            <div className="store__product-card-image">
                {showPlaceholder ? (
                    <div className="store__product-card-image-placeholder" />
                ) : (
                    <img
                        src={mainImage!}
                        alt={product.images?.[0]?.alt || product.name}
                        loading="lazy"
                        onError={() => setImageError(true)}
                    />
                )}

                {onSale && inStock && (
                    <span className="store__product-card-badge store__product-card-badge--sale">Promocja!</span>
                )}
            </div>

            <div className="store__product-card-body">
                <h3 className="store__product-card-name">{product.name}</h3>

                {product.short_description && (
                    <div 
                        className="store__product-card-description"
                        dangerouslySetInnerHTML={{ __html: product.short_description }}
                    />
                )}

                <div className="store__product-card-footer">
                    <div className="store__product-card-price">
                        {onSale && displaySalePrice ? (
                            <>
                                <span className="store__product-card-price--sale">{formatPrice(displaySalePrice)}</span>
                                <span className="store__product-card-price--regular">
                                    {formatPrice(displayRegularPrice || displayPrice)}
                                </span>
                            </>
                        ) : (
                            <span>{formatPrice(displayPrice)}</span>
                        )}
                    </div>

                    <span
                        className={`store__product-card-stock ${
                            inStock ? 'store__product-card-stock--available' : 'store__product-card-stock--unavailable'
                        }`}
                    >
                        {inStock ? 'Dostępny' : 'Niedostępny'}
                    </span>
                </div>
            </div>
        </div>
    );
}
